// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"3c370c04","453":"1b9aa114","732":"51a08e8a","977":"bf2f6c9f"}[chunkId] + ".chunk.js";
};